module.exports = __webpack_public_path__ + "img/agb.efa4006.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/nuxt/assets/images/agb.jpg
// module id = pGH2
// module chunks = 21